'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = shouldFetchRange;

var _isExpired = require('../status/is-expired');

var _isExpired2 = _interopRequireDefault(_isExpired);

var _isOk = require('../status/is-ok');

var _isOk2 = _interopRequireDefault(_isOk);

var _isError = require('../status/is-error');

var _isError2 = _interopRequireDefault(_isError);

var _isLoading = require('../status/is-loading');

var _isLoading2 = _interopRequireDefault(_isLoading);

var _entries2 = require('./_entries');

var _entries3 = _interopRequireDefault(_entries2);

var _list2 = require('./_list');

var _list3 = _interopRequireDefault(_list2);

var _total2 = require('./_total');

var _total3 = _interopRequireDefault(_total2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function shouldFetch(entry) {
    // If entry is in a valid state don't refresh it
    var isValid = (0, _isOk2.default)(entry) || (0, _isLoading2.default)(entry) || (0, _isError2.default)(entry);

    return !isValid || (0, _isExpired2.default)(entry);
}

function shouldFetchRange(root, listName, start, end) {
    var list = (0, _list3.default)(root, listName);
    var total = (0, _total3.default)(list);

    if (total < 1) return shouldFetch(list);

    end = Math.min(end, total - 1); // Limit end to the number of entries
    end = Math.max(0, end); // Prevent negative numbers (when total == 0)

    var entries = (0, _entries3.default)(root, listName, start, end);

    return entries.reduce(function (r, entry) {
        return r || shouldFetch(entry);
    }, false);
}